import { DriverInfo, DriverType } from '../DriverInfo';
import { v4 as uuid } from 'uuid';

export interface ODSPNewFileInfo {
  siteUrl: string;
  driveId: string;
  filename: string;
  filePath: string;
}

/**
 * Creates DriverInfo for a new file in ODSP
 * @param newFileInfoPromise Promise to supply info necessary for creating the file
 */
export function resolveODSPDriverInfoForNewFile(newFileInfoPromise: Promise<ODSPNewFileInfo>): DriverInfo {
  return {
    type: DriverType.SPO,
    documentUrl: `/?uniqueId=${uuid()}`,
    componentId: '/',
    newFileInfoPromise
  };
}
